import * as moment from 'moment';
import { StatusEnum } from '../models/status-enum.model';
import { StatusEmailEnum } from '../models/status-email-enum.model';
import { TipoLocalEnum } from '../models/tipo-local-enum.model';
import { ModulesEnum } from '../models/modules-enum.model';
import { Router } from '@angular/router';
import { AbstractControl, FormGroup } from '@angular/forms';
import { PageEnum } from '../models/page-enum.model';
import { StatusCertificadoEnum } from '../models/status-certificado-enum.model';
import { HistoricoAcaoEnum } from '../models/historico-acao-enum.model';
import { StatusSolicitacaoEnum } from '../models/status-solicitacao-enum.model';
import { verticalMenuItems } from '../../../app/theme/components/menu/menu';
import { CodigoACIEnum } from '../models/codigo-aci-enum.model';
import { StatusPagamentoEnum } from '../models/status-pagamento-enum.model';
import { ProdutoModeloEnum } from '../models/produto-modelo-enum.model';
import { MidiaEnum } from '../models/midia-enum';
import { TipoEmissaoEnum } from '../models/tipo-emissao-enum.model';
export abstract class Util {

    public static EhSafewebHost(): boolean {
        return window.location.host.includes('acsafeweb') || window.location.host.includes('localhost');
    }

    public static getStatus() {
        return [{
            Value: 'true',
            Description: 'Emitido'
        },
        {
            Value: 'false',
            Description: 'Não Emitido'
        }];
    }

    public static getMidias() {
        return [{
            idMidiaTipo: 1,
            Nome: 'Cartão'
        },
        {
            idMidiaTipo: 2,
            Nome: 'Token'
        },
        {
            idMidiaTipo: 3,
            Nome: 'PSC'
        },
        {
            idMidiaTipo: 4,
            Nome: 'HSM'
        },
        {
            idMidiaTipo: 5,
            Nome: 'Arquivo'
        },
        {
            idMidiaTipo: 6,
            Nome: 'Sem mídia'
        }];
    }

    // Método utilizado para fazer validators condicionais (obs: não funciona corretamente com validators async)
    public static conditionalValidator(predicate, validator) {
        return (formControl => {
            if (!formControl.parent) {
                return null;
            }
            if (predicate()) {
                return validator(formControl);
            }
            return null;
        });
    }

    public static getMensagemCampoObrigatorio() {
        return 'Campo obrigatório.';
    }

    public static getMensagemCampoCaracteresEspeciais() {
        return 'Campo não pode conter caracteres especiais.';
    }

    public static getMensagemCampoInvalido() {
        return 'Campo inválido.';
    }

    public static convertDataToUTC(date) {
        return (moment(date).utc().format('YYYY-MM-DD'));
    }

    public static checkFormDates(dtInicio, dtFim) {
        if ((dtInicio != null && dtFim == null) ||
            (dtInicio == null && dtFim != null)) {
            return 'Você precisa informar as datas de início e fim.';
        }

        if (Util.diffData(dtInicio, dtFim) < 0
        ) {
            return 'A data de início não pode ser maior que a do fim.';
        }

        return '';
    }

    public static compareDates(dtInicio, dtFim) {
        if (dtInicio != null && dtFim != null && Util.diffData(dtInicio, dtFim) < 0) {
            return 'A data de início não pode ser maior que a do fim.';
        }

        return '';
    }

    /**
      * Ordena o Array [arr] de acordo com o Campo [field] de data.
       */
    public static orderByDate(arr, field) {
        return arr.sort((a, b) => {
            a = new Date(a[field]);
            b = new Date(b[field]);
            return a > b ? -1 : a < b ? 1 : 0;
        });
    }

    /**
  * Retorna somente a data no formato brasileiro.
  */
    public static convertDataToPtBR(date) {
        if (moment(date).isValid()) {
            return moment(date).utc().format('DD/MM/YYYY');
        } else {
            return null;
        }
    }

    /**
  * Retorna a data e hora no formato brasileiro.
  */
    public static convertDatetimeToPtBR(date) {
        if (moment(date).isValid()) {
            return moment(date).format('DD/MM/YYYY HH:mm:ss');
        } else {
            return null;
        }
    }

    public static convertDatetimeToTimePtBR(data, considerarSegundos = false) {
        if (moment(data).isValid()) {
            let formatacao = 'HH:mm';
            formatacao += (considerarSegundos) ? ':ss' : '';
            return moment(data).format(formatacao);
        } else {
            return null;
        }
    }

    public static validateField(valor) {
        if (!valor || valor === 'false') {
            return 'Inválido';
        } else {
            return 'Válido';
        }
    }

    public static dateIsValid(date) {
        return (moment(date).utc().isAfter('0001-01-01'));
    }

    /**
  * Retorna a diferença em dias das datas [dtInicio] e [dtFim]
  */
    public static diffData(dtInicio, dtFim) {
        dtInicio = moment(dtInicio).startOf('day');
        dtFim = moment(dtFim).startOf('day');
        return dtFim.diff(dtInicio, 'days');
    }

    /**
  * Adiciona a quantidade de dias [numbersDay] na data [data]
  */
    public static addDays(data: Date, numbersDay: number) {
        return moment(data).utc().add(numbersDay, 'days').utc().format('YYYY-MM-DD');
    }

    /**
  * Ordena o Array [arr] de acordo com o Campo [field]
  */
    public static orderBy(arr, field) {
        return arr.sort((a, b) => {
            return a[field].toString().localeCompare(b[field].toString());
            // if (a[field] > b[field]) {
            // }
            // if (a[field] < b[field]) {
            //     return -1;
            // }
            // return 0;
        });
    }

    public static getEnumDescription(e: any, id: number, pos: number = 0): string {
        return (e[e[id].toString() + 'Description']).split(';')[pos];
    }

    public static getStatusEnumName(status) {
        return StatusEnum[status];
    }

    public static getLocalAtendimentoTipoEnumName(status) {
        return TipoLocalEnum[status];
    }

    public static getStatusEmailEnumName(status) {
        return StatusEmailEnum[status];
    }

    /**
  * Método responsável por retornar class correspondente ao Status.
  *
  * Styles:
  * Habilitado e Aprovado => success
  * Desabilitado, Suspenso, Reprovado e Email.Erro => danger
  * Pendente, EmCredenciamento, EmAnalise e Email.Pendente => warning
  * Cancelado e Vencido => info
  */
    public static getStatusEnumClass(status) {
        if (status === StatusEnum.Habilitado || status === StatusEmailEnum.Enviado || status === 'true' || status === HistoricoAcaoEnum.Adicionado) {
            return 'success';
        } else if (status === StatusEnum.Desabilitado || status === HistoricoAcaoEnum.Excluido) {
            return 'danger';
        } else if (status === StatusEnum.Pendente || status === StatusEmailEnum.Pendente || status === HistoricoAcaoEnum.Modificado) {
            return 'warning';
        } else if (status === StatusEnum.Suspenso) {
            return 'danger';
        } else if (status === StatusEnum.Cancelado) {
            return 'info';
        } else if (status === StatusEnum.EmCredenciamento) {
            return 'warning';
        } else if (status === StatusEnum.EmAnalise) {
            return 'warning';
        } else if (status === StatusEnum.Aprovado) {
            return 'success';
        } else if (status === StatusEnum.Reprovado || status === StatusEmailEnum.Erro || status === 'false') {
            return 'danger';
        } else if (status === StatusEnum.Vencido) {
            return 'info';
        }
    }

    public static getCodigoACIEnumClass(status) {
        if (status === CodigoACIEnum.PendenteAprovacao) {
            return 'warning';
        } else if (status === CodigoACIEnum.PendenteRecebimento) {
            return 'orange';
        } else if (status === CodigoACIEnum.Aprovado) {
            return 'success';
        } else if (status === CodigoACIEnum.Revogado) {
            return 'danger';
        } else if (status === CodigoACIEnum.Concluido) {
            return 'primary';
        } else {
            return 'secondary';
        }
    }

    /**
  * Método responsável por retornar class correspondente ao Status do Certificado.
  *
  * Styles:
  * Nenhum => secondary
  * Pendente => warning
  * Emitido => success
  * Revogado, Cancelado => danger
  */
    public static getStatusCertificadoEnumClass(status) {
        if (status === StatusCertificadoEnum.Nenhum) {
            return 'secondary';
        } else if (status === StatusCertificadoEnum.Pendente) {
            return 'warning';
        } else if (status === StatusCertificadoEnum.Emitido) {
            return 'success';
        } else if (status === StatusCertificadoEnum.Revogado || status === StatusCertificadoEnum.Cancelado) {
            return 'danger';
        }
    }

    /**
  * Método responsável por retornar class correspondente ao Status da Solicitacao.
  *
  * Styles:
  * Nenhum => secondary
  * Cancelado => danger
  * Ativo => success
  */
    public static getStatusSolicitacaoEnumClass(status) {
        if (status === StatusSolicitacaoEnum.Nenhum) {
            return 'secondary';
        } else if (status === StatusSolicitacaoEnum.Ativo) {
            return 'success';
        } else if (status === StatusSolicitacaoEnum.Cancelado) {
            return 'danger';
        }
    }


    /**
  * Método responsável por retornar class correspondente ao Status do Pagamento.
  *
  * Styles:
  * Default: Nenhum, Chargeback => secondary
  * Pendente, Processamento, EmDisputa => warning
  * Liberado, Autorizado, Disponivel => success
  * Devolvido, EmCancelamento, Recusado, Baixado => danger
  */
    public static getStatusPagamentoEnumClass(status: StatusPagamentoEnum) {
        switch (status) {
            case StatusPagamentoEnum.Pendente:
            case StatusPagamentoEnum.Processamento:
            case StatusPagamentoEnum.EmDisputa:
                return 'warning';
                break;
            case StatusPagamentoEnum.Liberado:
            case StatusPagamentoEnum.Autorizado:
            case StatusPagamentoEnum.Disponivel:
                return 'success';
                break;
            case StatusPagamentoEnum.Devolvido:
            case StatusPagamentoEnum.EmCancelamento:
            case StatusPagamentoEnum.Recusado:
            case StatusPagamentoEnum.Baixado:
            case StatusPagamentoEnum.Chargeback:
                return 'danger';
            default:
                return 'secondary';
        }
    }


    /**
  * Método responsável por gerar uma lista com de assinaturas para enviar ao PluginAssinatura.
  * Quando encontrar dados a serem assinados na Entidade, retorna em uma lista de Base64.
  *
  * isLocalAtendimento : Caso seja Local de Atendimento realiza apenas a assinatura da Entidade.
  */
    public static buildBase64SignaturesList(entidade: any, isLocalAtendimento: boolean): string[] {
        const base64SignatureList = [];

        base64SignatureList.push(btoa(JSON.stringify(entidade)));
        if (!isLocalAtendimento) {
            base64SignatureList.push(btoa(JSON.stringify(entidade.Coordenador)));
        }
        return base64SignatureList;
    }


    /**
     * Método responsável por remover os caracteres especiais de uma string.
     * @param text String que deve ser limpa.
     */
    public static removeSpecialCharacter(text: string) {
        return text.replace(/[^a-zA-Z ]/ig, '').trim();
    }

    /**
     * Método responsável retornar o módulo o qual o usuário está acessando de acordo com seu Router.
     * @param route Router que deve ser instanciada.
     */
    public static getModuleByRoute(route: Router): ModulesEnum {
        let cfg;
        let current_url = route.url.split('/')[2].trim();
        if (current_url) {
            const actualUserRoutes = (route.config[1] as any)._loadedConfig;
            if (actualUserRoutes) {
                cfg = actualUserRoutes.routes[0].children.find(childrenRoute => childrenRoute.path === current_url);
            }
        }
        if (!cfg.data.permission) {
            current_url = route.url.split('/')[3].trim();
            cfg = cfg._loadedConfig.routes.find(child => child.path === current_url);
        }
        return +ModulesEnum[cfg.data.permission];
    }

    /**
       * Retorna a rota da permissão de acordo com o model do menu.
       * @param module Modulo que deseja ver a rota.
       */
    public static getRouteByMenuModel(module: ModulesEnum): string {
        const route = verticalMenuItems.find(menu => menu.permission && menu.permission === module);

        return route.routerLink;
    }

    /**
    * Método responsável por retornar uma lista de anos.
    * @param startYear Ano inicial, retornará uma lista até o ano atual.
    */
    public static getListYears(startYear) {
        const currentYear = new Date().getFullYear(), years = [];
        startYear = startYear || 1980;

        while (startYear <= currentYear) {
            years.push(startYear++);
        }

        return years.reverse();
    }

    /**
     * Gera um array do ano corrente até o range solicitado.
     * @param range Range de anos para gerar a lista.
     */
    public static generateYearsArray(range: number) {
        const currentYear = new Date().getFullYear();
        const years = [currentYear];

        for (let i = 1; i <= range; i++) {
            years.push(currentYear + i);
        }

        return years;
    }

    /**
     * Método responsável por setar nulo para controles que estejam com valor vazio.
     * @param control FormControl que deve ser validado.
     */
    public static validateControl(control: AbstractControl) {
        if (control.value === '') {
            control.setValue(null);
        }
    }

    /**
     * Método responsável validar se o form do tipo email está valido.
     * @param control FormControl que deve ser validado.
     */
    public static validateEmailControl(control: AbstractControl) {
        const reUpdated = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return control.value === null ? false : reUpdated.test(control.value);
    }

    /**
     * Método responsável por retornar o array de butons baseados no pageMode.
     * @param btnArray Array com os buttons da página.
     * @param pageMode PageEnum atual.
     */
    public static adjustFloaterButtons(btnArray: any, pageMode: PageEnum): any[] {
        let arr = [];

        switch (pageMode) {
            case PageEnum.Visualizando:
                arr = btnArray.filter(x => x.iconClass !== 'fa fa-save');
                break;
            default:
                arr = btnArray.filter(x => x.iconClass !== 'fa fa-edit');
                break;
        }
        return arr;
    }

    /**
     * Retorna a string equivalente ao código alpha 3 do Brasil.
     */
    public static getAlphaCodeBrazil(): string {
        return 'BRA';
    }

    /**
     * Retorna a configuração padrão de intervalo de dias máximo para pesquisas com data.
     */
    public static getMaxIntervalFilterDays(): number {
        return 45;
    }

    /**
     * Gera um guid randômico.
     */
    public static generateGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    public static getDiaSemana(data: Date, diaAbreviado: boolean = false): string {
        const dias = [
            { abreviado: 'Dom', completo: 'Domingo' },
            { abreviado: 'Seg', completo: 'Segunda' },
            { abreviado: 'Ter', completo: 'Terça' },
            { abreviado: 'Qua', completo: 'Quarta' },
            { abreviado: 'Qui', completo: 'Quinta' },
            { abreviado: 'Sex', completo: 'Sexta' },
            { abreviado: 'Sáb', completo: 'Sábado' }
        ];
        const chaveFormatoNome = diaAbreviado ? 'abreviado' : 'completo';

        const diaSemana = data.getDay();
        return dias[diaSemana][chaveFormatoNome];
    }

    /**
     * Deixa as primeiras letras de todas as palavras com letra maiúsculas.
     * @param texto texto a ser capitalizado
     */
    public static capitalizeText(texto: string) {
        if (texto === undefined) {
            return texto;
        }

        const splitStr = texto.toLowerCase().split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    /**
  * Retorna o nome da AC de acordo com a URL
  */
    public static getACByHost() {
        const ac = (window.location.hostname).split('-')[0];

        return (ac.includes('localhost') || window.location.hostname.includes('d-acsafeweb')) 
            ? 'ACSAFEWEB' 
            : ac.includes('.') 
                ? (ac.split('.')[0]).toUpperCase() 
                : ac.toUpperCase();
    }

    /**
     * Retorna o ambiente de acordo com a URL
     */
    public static getEnvironmentByHost() {
        const host = (window.location.hostname).split('-');

        if (host[0].includes('localhost') || window.location.hostname.includes('d-acsafeweb')) {
            return 'DESENVOLVIMENTO';
        } else if (host[0].includes('.')) {
            return 'PRODUCAO';
        } else {
            return ((host[1].split('.'))[0]).toUpperCase();
        }
    }

    public static getTokenByHost() {
        const host = (window.location.hostname).split('-');
        if (host[0].includes('localhost')) {
            return '8gafzq4qneqftj5sx6qj';
        } else if (host[0].includes('.')) {
            return '9gafzq4qneqftj5sx6qj';
        } else {
            return '8gafzq4qneqftj5sx6qj';
        }
    }

    /**
     * desabilita campo acessório quando produto = A1 ou midia = PSC
     * habilita campo acessorio nos outros casos
     */
    public static desabilitaCampoAcessorio(formulario: FormGroup, listaProdutos: Array<any>, idProduto: number, idMidiaTipo: number) {

        let idAcessorio = formulario.controls['idAcessorio'];
        let produto = listaProdutos.find(p => p.idProduto == idProduto)
        if ((produto && produto.Modelo === ProdutoModeloEnum.A1) || idMidiaTipo === MidiaEnum.PSC) {
            idAcessorio.disable({emitEvent: false});
            idAcessorio.setValue(null, {emitEvent: false})
        } else
            idAcessorio.enable({emitEvent: false});

    }

    public static renomeiaTipoEmissao(tipoExibidos){
        return tipoExibidos.map(x => {
            switch (x.id) {
                case TipoEmissaoEnum.EmissaoPresencial:
                    return { id: x.id, name: 'Presencial' };
                break;
                case TipoEmissaoEnum.RenovacaoOnline:
                    return { id: x.id, name: 'Renovação on-line' };
                break;
                case TipoEmissaoEnum.EmissaoVideoconferencia:
                    return { id: x.id, name: 'Videoconferência' };
                break;
                case TipoEmissaoEnum.EmissaoAutonoma:
                    return { id: x.id, name: 'Autônoma' };
                break;
                case TipoEmissaoEnum.EmissãoOnline:
                    return { id: x.id, name: 'Emissão on-line' };
                break;
                default:
                    return { id: x.id, name: x.name };
                break;
            }                        
        });
    }

    public static converterTelefone(phoneNumber: string): string {
        const numericPhoneNumber = phoneNumber.replace(/\D/g, '');
    
        if (numericPhoneNumber.length === 10) {
          return numericPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        } else if (numericPhoneNumber.length === 11) {
          return numericPhoneNumber.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
        } else {
          return phoneNumber;
        }
      }
}
